<template>
    <div class="row left-content">
        <div class="col-12">
            <h1>Api keys</h1>
        </div>
        <div class="col-9">
            <div class="white-block">
                <div class="container">
                    <ul>
                        <li><b>Test: </b>{{ userData.tokens ? userData.tokens.test : '' }}</li>
                        <li><b>Live: </b>{{ userData.tokens ? userData.tokens.live : '' }}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Settings",
    data() {
        return {
            userData: this.$store.state.userData
        }
    },
}
</script>